import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LinkedinClean = function LinkedinClean(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0.157022 12.157H2.86777V4.22314H0.157022V12.157Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.0214844 1.57851C0.0214844 2.38909 0.689682 3.04495 1.51239 3.04495C2.3351 3.04495 3.0033 2.38909 3.0033 1.57851C3.0033 0.769251 2.33646 0.112061 1.51239 0.112061C0.688327 0.112061 0.0214844 0.769251 0.0214844 1.57851Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.64734 12.157H12.3554V7.71537C12.3554 3.37289 8.11576 3.53157 6.93388 5.66843V4.22314H4.22314V12.157H6.93388V8.37388C6.93388 6.09686 9.64734 5.88661 9.64734 8.37388V12.157Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default LinkedinClean;